import React, { useState } from "react";
import { ReactComponent as WelcomeMessage } from "assets/img/icons/person-voice-svgrepo-com.svg";
import { Modal } from "react-responsive-modal";
import GeneralService from "services/GeneralService";
import TeamService from "services/TeamService";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import Button from "components/CustomButton";
import * as Yup from "yup";
import ButtonWithProgress from "components/ButtonWithProgress";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { useTeamContext } from "store/contexts/teamContext";
import { useToasts } from "react-toast-notifications";

var styles = {
  iconStyle: {
    width: "14px",
    height: "14px",
  },
  modalContext: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: "250px",
  },
  modalHeading: {
    display: "flex",
    justifyContent: "center",
  },
  attachmentSelection: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    width: "40px !important",
  },
};

export default ({ updateOption }) => {
  const dispatch = useDispatch();
  const classes = styles;
  const { team } = useTeamContext();
  const [showDialog, setShowDialog] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { addToast } = useToasts();

  const formik = useFormik({
    initialValues: {
      attachment: null,
    },
    validationSchema: Yup.object().shape({
      attachment: Yup.string().required("Please select or record any media."),
    }),
    onSubmit: async (values) => {
      try {
        let media = null;

        if (values.attachment) {
          const preSignedResponse = await GeneralService.getPresignedUploadURL({
            filename: values.attachment.name,
            mime_type: values.attachment.type,
            file_size: values.attachment.size,
            resource_type: "team",
            resource_id: team.id,
            resource_policy: "team.welcome.message",
          });

          const { key, url } = preSignedResponse.data.data;

          media = key;

          await GeneralService.uploadToS3(
            url,
            values.attachment,
            (progress) => {
              setUploadProgress(progress);
            }
          );
        }

        setUploadProgress(100);

        var response = await TeamService.createWelcomeMessage(team.id, {
          media,
          attachment: values.attachment,
        });

        response.data.data.type = "welcomemessage";

        if (values.attachment) {
          var attachmentType = values.attachment.type.split("/");
          var type = attachmentType[0];
        }

        formik.resetForm();
        setUploadProgress(0);

        updateOption();
        setShowDialog(false);

        if (type && type === "video") {
          addToast(
            "Your welcome message post is being processed. We’ll let you know when it’s ready to view. ",
            { appearance: "info" }
          );
          return;
        }

        addToast("Your welcome message post is created successfully. ", {
          appearance: "success",
        });

        dispatch(timelineActions.createPost(response.data.data));
      } catch (e) {
        console.log(e);
      }
    },
  });

  const onAttachmentSelected = (file) => {
    formik.setFieldValue("attachment", file);
  };

  const clearAttachment = () => {
    formik.setFieldValue("attachment", null);
  };

  const closeRecordModal = () => {
    clearAttachment();
    setShowDialog(false);
  };

  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={() => setShowDialog(true)}>
        <WelcomeMessage className="mx-2" style={classes.iconStyle} />
        <span style={classes.headingTextColor}>Record a Welcome </span>
        <span className='headingSecondaryTextColor'>Message</span>
      </div>
      <Modal
        open={showDialog}
        onClose={() => setShowDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "recorderPadding" }}
      >
        <form noValidate onSubmit={formik.handleSubmit}>
          <div style={classes.modalHeading}>
            <div className="modalHeader">{team?.name}</div>
          </div>
          <div className="modalContent">
            <div style={classes.modalContext}>
              <div>Record Welcome Message For Your Team Members.</div>
              {!!formik.values.attachment && (
                <div style={{ padding: "50px" }}>
                  <AttachmentPreview
                    attachment={formik.values.attachment}
                    clearAttachment={clearAttachment}
                  />
                </div>
              )}
              <div style={classes.attachmentSelection}>
                <AttachmentSelection
                  selectors={["audio", "video"]}
                  accepted={[".mp3", ".mp4"]}
                  onChange={onAttachmentSelected}
                />
              </div>
            </div>
          </div>
          <div className="modalAction">
            <Button
              disabled={formik.isSubmitting && true}
              onClick={closeRecordModal}
              buttonClass="small-btn me-2"
            >
              Cancel
            </Button>
            <ButtonWithProgress
              initialText={"Submit"}
              isSubmitting={formik.isSubmitting}
              buttonWithProgressClass="small-accept-btn"
              progress={uploadProgress}
              isValid={formik.isValid && formik.dirty}
            />
          </div>
        </form>
      </Modal>
    </>
  );
};
